import * as am5 from "@amcharts/amcharts5"
import * as am5hierarchy from "@amcharts/amcharts5/hierarchy"
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting"
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated"
import {useEffect} from "react"
import {RootState} from "../../rootReducer"
import {SpinnerGrid} from "../../shared/CommonItems"
import {useAppSelector} from "../../store"

export const SunburstChart = () => {
    const selectedDealer = useAppSelector((state: RootState) => state.application.selectedSingleDealer)
    const passRateCount = useAppSelector((state: RootState) => state.containers.dashboard.passrateCountDetail)
    const isLoadingPassRateCount = useAppSelector(
        (state: RootState) => state.containers.dashboard.isLoadingPassRateCount,
    )
    useEffect(() => {
        if (selectedDealer && passRateCount) {
            DrillDownChart(passRateCount)
        }
    }, [selectedDealer, passRateCount])

    const maybeDisposeRoot = (divId: string) => {
        am5.array.each(am5.registry.rootElements, function (root) {
            if (root && root.dom != null && root.dom.id === divId) {
                root.dispose()
            }
        })
    }
    const DrillDownChart = (chartdata: any) => {
        maybeDisposeRoot("sunburstChart")
        const root = am5.Root.new("sunburstChart")

        root.setThemes([am5themes_Animated.new(root)])

        am5plugins_exporting.Exporting.new(root, {
            menu: am5plugins_exporting.ExportingMenu.new(root, {}),
            filePrefix: "Test Result",
        })
        const container: any = root.container.children.push(
            am5.Container.new(root, {
                width: am5.percent(100),
                height: am5.percent(100),
                layout: root.verticalLayout,
            }),
        )

        const series = container.children.push(
            am5hierarchy.Sunburst.new(root, {
                downDepth: 3,
                initialDepth: 3,
                topDepth: 1,
                innerRadius: am5.percent(20),
                valueField: "value",
                categoryField: "name",
                childDataField: "children",
                tooltip: am5.Tooltip.new(root, {
                    interactiveChildren: true,
                    getLabelFillFromSprite: false,
                    getFillFromSprite: true,
                    pointerOrientation: "left",
                    autoTextColor: false,
                }),
            }),
        )
        if (chartdata[0].children[0].name === "FAIL") {
            series.get("colors").set("colors", [
                am5.color(0xfd625e), //fail
                am5.color(0xa66999), //prs
                am5.color(0x01b8aa), //pass
            ])
        } else {
            series.get("colors").set("colors", [
                am5.color(0x01b8aa), //pass
            ])
        }

        series.labels.template.setAll({
            fill: root.interfaceColors.get("alternativeBackground"),
        })

        series.nodes.template.set("tooltipText", `[0xffffff]{category} bookings {sum}`)

        series.data.setAll(chartdata)
        series.selectDataItem(series.dataItems[0])

        series.appear(1000, 100)
    }

    return (
        <>
            {isLoadingPassRateCount && <SpinnerGrid />}
            <div className="h-100" id="sunburstChart"></div>
        </>
    )
}
